module.exports = __webpack_public_path__ + "img/629b5d7.jpg";